
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1201Row.Fields;
    @Serenity.Decorators.registerClass()
    export class Report_1201Grid extends Serenity.EntityGrid<Report_1201Row, any> {
        protected getColumnsKey() { return Report_1201Columns.columnsKey; }
        protected getDialogType() { return Report_1201Dialog; }
        protected getIdProperty() { return Report_1201Row.idProperty; }
        protected getInsertPermission() { return Report_1201Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1201Row.localTextPrefix; }
        protected getService() { return Report_1201Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
       
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

           let descriptions: string[] = [];

            if (request?.Criteria) {
                let criteria = request.Criteria.toString().split(',');
                let key: string = criteria[0];

                let n = columns.find(n => {
                    return options.columnStyles[n]['field'] === key
                });
                if (n) {
                    key = options.columnStyles[n]['title'];
                }

                let d1 = criteria.findIndex(c => c == ">=");
                if (d1 >= 0) {
                    let v1 = criteria[d1 + 1];
                    let d2 = criteria.findIndex(c => c == "<");
                    
                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];
                        
                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy"+' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy"+' (00:00)')}`);

                    } else {
                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
                    }
                } else {
                    let d2 = criteria.findIndex(c => c == "<");
                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];
                        descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
                    }
                }
            } else {
                descriptions.push("วันที่ = ไม่ระบุ");
            }

            // console.log(request)
            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();

                let filters = Object.keys(request.EqualityFilter);

                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    // if else{
                    if (filterValue.length > 0) {
                        if (Array.isArray(filterValue)) {
                            if (quickFilter.options.lookupKey) {
                                // console.log(filterValue);
                                (filterValue as any[]).forEach(value => {
                                    var names: string[] = new Array(filterValue);
                                    for (var i = 0; i < names.length; i++) {
                                        filterValue = (names[i]);
                                        console.log(filterValue);
                                    }
                                })

                            }
                        } else {
                            filterValue
                        }
                    }
                    else {
                        filterValue = "ไม่ระบุ"
                    }
                    // }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {
                        descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                    }
                }
            }
            return [descriptions, gridColumns];
        }


        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(4, 0, {
                id: 'Print PsTaxInvoiceprint',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-PsTaxInvoiceprint" title="PsTaxInvoiceprint">' +
                        '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });

            columns.splice(5, 0, {
                id: 'Print PsTaxInvoiceprint',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-PsTaxInvoiceprint-A4" title="PsTaxInvoiceprint">' +
                        '<i class="fa fa-file-pdf-o text-green"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });

            return columns;
        }
        // protected getViewOptions() {
        //     var opt = super.getViewOptions();
        //     opt.localSort = true;
        //     return opt;
        // }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            // if (e.isDefaultPrevented())
            //     return;

            var item = this.itemAt(row);
            var target = $(e.target);


            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('print-PsTaxInvoiceprint')) {
                    this.view.getRows()
                    const request = this.getView().params as ReprintReceiptData
                    request.DocNo = item.DocNo

                    let PosId = item.PosId;
                    let fg = Q.tryFirst(Lookups.VpoSparamRow.getLookup().items, x => x.PosId == PosId)
                    if(fg != null){
                    let sss = fg.ShopLogoOnReceipt;
                    if (!Q.isEmptyOrNull(sss)) {
                        let vp = window.location.href.replace("#", "")
                        console.log(vp)
                        let ap = vp.replace("/ReportMasterData/Report_1201", "")
                        request.URLpic = ap + "/upload/" + fg.ShopLogoOnReceipt;
                    } else {
                        request.URLpic = "/images/SARAPADTHAIENG.png" //wwwroot\Content\site\images\SARAPADTHAIENG.png

                    }
                    request.TaxId = fg.TaxId ?? "";
                    request.PosPermitNo = fg.PosPermitNo ?? "";
                    request.RecptHeadMesg1 = fg.RecptHeadMesg1 ?? "";
                    request.RecptHeadMesg2 = fg.RecptHeadMesg2 ?? "";
                    request.RecptHeadMesg3 = fg.RecptHeadMesg3 ?? "";
                    request.RecptHeadMesg4 = fg.RecptHeadMesg4 ?? "";
                    request.RecptHeadMesg5 = fg.RecptHeadMesg5 ?? "";
                    request.RecptHeadMesg6 = fg.RecptHeadMesg6 ?? "";

                    request.RecptFootMesg1 = fg.RecptFootMesg1 ?? "";
                    request.RecptFootMesg2 = fg.RecptFootMesg2 ?? "";
                    request.RecptFootMesg3 = fg.RecptFootMesg3 ?? "";
                    request.RecptFootMesg4 = fg.RecptFootMesg4 ?? "";
                    request.RecptFootMesg5 = fg.RecptFootMesg5 ?? "";
                    request.RecptFootMesg6 = fg.RecptFootMesg6 ?? "";
                    request.RecptFootMesg7 = fg.RecptFootMesg7 ?? "";
                    request.RecptFootMesg8 = fg.RecptFootMesg8 ?? "";
                    request.RecptFootMesg9 = fg.RecptFootMesg9 ?? "";
                    request.RecptFootMesg10 = fg.RecptFootMesg10 ?? "";
                    
                }

                request.Header = Q.tryFirst(Report_1201Row.getLookup().items, x => x.DocNo == item.DocNo)
                request.times = item.DocTime.toString().substring(0,5)
                console.log (item.DocTime.toString().substring(0,5))

                    let doc = item.Factor
                    let vat = item.SalesVatType;

                    if(doc == 1){
                        if (vat == "E") {
                            request.Type = 2
                        } else {
                            request.Type = 1
                        }
                    }else{
                        if (vat == "E") {
                            request.Type = 4
                        } else {
                            request.Type = 3
                        }
                    }
                    




                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                      

                        ;
                }

                if (target.hasClass('print-PsTaxInvoiceprint-A4')) {
                    this.view.getRows()
                    const request = this.getView().params as ReprintReceiptData
                    request.DocNo = item.DocNo

                    let PosId = item.PosId;
                    let fg = Q.tryFirst(Lookups.VpoSparamRow.getLookup().items, x => x.PosId == PosId)
                    console.log(fg)
                    if(fg != null){


                    let sss = fg.ShopLogoOnReceipt;

                    console.log(fg.ShopLogoOnReceipt)

                    if (!Q.isEmptyOrNull(sss)) {
                        let vp = window.location.href.replace("#", "")
                        console.log(vp)
                        let ap = vp.replace("/ReportMasterData/Report_1201", "")
                        request.URLpic = ap + "/upload/" + fg.ShopLogoOnReceipt.replace(" ", "%20");

                        
                    } else {
                        request.URLpic = "/Content/site/images/SARAPADTHAIENG.png" //wwwroot\Content\site\images\SARAPADTHAIENG.png

                    }

                    console.log(request.URLpic)
                    request.TaxId = fg.TaxId ?? "";
                    request.PosPermitNo = fg.PosPermitNo ?? "";
                    request.RecptHeadMesg1 = fg.RecptHeadMesg1 ?? "";
                    request.RecptHeadMesg2 = fg.RecptHeadMesg2 ?? "";
                    request.RecptHeadMesg3 = fg.RecptHeadMesg3 ?? "";
                    request.RecptHeadMesg4 = fg.RecptHeadMesg4 ?? "";
                    request.RecptHeadMesg5 = fg.RecptHeadMesg5 ?? "";
                    request.RecptHeadMesg6 = fg.RecptHeadMesg6 ?? "";

                    request.RecptFootMesg1 = fg.RecptFootMesg1 ?? "";
                    request.RecptFootMesg2 = fg.RecptFootMesg2 ?? "";
                    request.RecptFootMesg3 = fg.RecptFootMesg3 ?? "";
                    request.RecptFootMesg4 = fg.RecptFootMesg4 ?? "";
                    request.RecptFootMesg5 = fg.RecptFootMesg5 ?? "";
                    request.RecptFootMesg6 = fg.RecptFootMesg6 ?? "";
                    request.RecptFootMesg7 = fg.RecptFootMesg7 ?? "";
                    request.RecptFootMesg8 = fg.RecptFootMesg8 ?? "";
                    request.RecptFootMesg9 = fg.RecptFootMesg9 ?? "";
                    request.RecptFootMesg10 = fg.RecptFootMesg10 ?? "";
                    
                }

                request.Header = Q.tryFirst(Report_1201Row.getLookup().items, x => x.DocNo == item.DocNo)
                    
                request.times = item.DocTime.toString().substring(0,5)
                console.log (item.DocTime.toString().substring(0,5))
                    let doc = item.Factor
                    let vat = item.SalesVatType;

                    if(doc == 1){
                        if (vat == "E") {
                            request.Type = 2
                        } else {
                            request.Type = 1
                        }
                    }else{
                        if (vat == "E") {
                            request.Type = 4
                        } else {
                            request.Type = 3
                        }
                    }
                    




                    Q.postToService({ service: this.getService() + '/ExportPdfA4', request: request, target: '_blank' })
                      

                        ;
                }

                

            }
        }

        protected usePager() {
            return false;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["DocDate","ShopId", "PosId"]);
        }
        
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

       

        protected markupReady() {
            super.markupReady();
    
            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            this.view.expandAllGroups(1);
            this.view.expandAllGroups(2);
        }


        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1201Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );       


            return buttons;
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            // var q = Q.parseQueryString();
            // if (q["posid"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "PosId");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["posid"];
            //     };
            // }


            return filters;
        }


        

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    new Slick.Aggregators.Sum('GrossSales'),
                    new Slick.Aggregators.Sum('AllItemDiscount'),
                    new Slick.Aggregators.Sum('AllItemCharge'),
                    new Slick.Aggregators.Sum('BillDiscount'),
                    new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('DocAmt'),
                    new Slick.Aggregators.Sum('Vat'),
                    new Slick.Aggregators.Sum('RoundAdjust'),
                    new Slick.Aggregators.Sum('NetSalesNormal'),
                    new Slick.Aggregators.Sum('NetSalesPromo'),
                    new Slick.Aggregators.Sum('NetSalesExVat'),
                    new Slick.Aggregators.Sum('NetSalesNonVat'),
                    new Slick.Aggregators.Sum('VatOfNetSales'),
                    new Slick.Aggregators.Sum('VatOfCharge'),
                    new Slick.Aggregators.Sum('BillCharge'),
                    new Slick.Aggregators.Sum('ReceiveCash'),
                    new Slick.Aggregators.Sum('ReceiveCreditCd'),
                    new Slick.Aggregators.Sum('ReceiveDebitCd'),
                    new Slick.Aggregators.Sum('ReceiveCoupon'),
                    new Slick.Aggregators.Sum('ReceiveCashCd'),
                    new Slick.Aggregators.Sum('ReceivePoint'),
                    new Slick.Aggregators.Sum('ReceiveOthers'),
                    new Slick.Aggregators.Sum('ReceiveNet')
                ]

            });

            this.view.setGrouping(
                [{
                    //formatter: x => 'รวมวันที่ ' + x.value,
                    formatter: function (g) {
                        return Q.formatDate(g.value, "dd/MM/yyyy");
                    },
                    getter: 'DocDate'
                    
                },
                {
                    formatter: x => 'รวมรหัสเครื่อง ' + x.value,
                    getter: 'ShopId'
                },

                {
                    // formatter: x => 'รวมรหัสเครื่อง ' + x.value.toString,
                    formatter: function (g) {
                        return Q.formatNumber(g.value, "#000");
                    },
                    getter: 'PosId'
                }
                ]
            );

            // new Serenity.AutoColumnWidthMixin({
            //     grid: this
            // });

            return grid;
        }
    }
}